"use client";

import { useInfiniteQuery } from "@tanstack/react-query";
import { listProfileBuddies } from "@/actions/buddy";

type UseProfileBuddiesOptions = {
  enabled?: boolean;
  query?: string;
  limit?: number;
};

export const buddiesKeys = {
  all: ["buddies"] as const,
  list: (userId: string, query?: string) =>
    ["buddies", userId, { query }] as const,
};

export function useProfileBuddies(
  userId: string,
  options: UseProfileBuddiesOptions = {},
) {
  const { enabled = true, query = "", limit = 20 } = options;

  return useInfiniteQuery({
    queryKey: buddiesKeys.list(userId, query),
    enabled: Boolean(userId && enabled),
    queryFn: async ({ pageParam }) => {
      const result = await listProfileBuddies({
        userId,
        cursor: pageParam ?? undefined,
        limit,
        query,
      });

      if (!result.ok) {
        throw new Error(result.message ?? "Failed to fetch buddies");
      }

      return result.data;
    },
    initialPageParam: null as number | null,
    getNextPageParam: (lastPage) =>
      lastPage.hasMore ? lastPage.nextCursor : undefined,
    staleTime: 60 * 1000, // 1 minute
  });
}
